import React from 'react';
import { ConnectedRouter } from 'connected-react-router'
import { Provider } from 'react-redux';
import { Route, Switch, BrowserRouter as Router } from 'react-router-dom';

import store, { history } from './store';
import './firebase/firebase';
import App from './containers/App';
import { NotificationContainer } from 'react-notifications';


const MainApp = () =>
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <Router basename="/portal">
        <Switch>
          <Route path="/" component={App} />
        </Switch>
      </Router>
    </ConnectedRouter>
    <NotificationContainer />
  </Provider>;


export default MainApp;
export { store }